module.exports = __webpack_public_path__ + "02_glasses_blue.ac7ab4eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer4/02_glasses_blue.png
// module id = nPk5
// module chunks = 0